import { applyMiddleware, compose, createStore } from 'redux';
import createRootReducer from 'reducers/index';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';

export const history = createBrowserHistory();

export const configureStore = () => {
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [routerMiddleware(history), thunk];

  const store = createStore(createRootReducer(history), composeEnhancers(applyMiddleware(...middlewares)));

  return store;
};



// WEBPACK FOOTER //
// ./src/configureStore.js